import React from 'react';
import './help.css'
import  Tutorial from '../images/tutorialColoured.png';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';

const help = () => {
  return (
    <div>
    <div>
      <Helmet>
        <title>Help | ENT Chatbot</title>
      </Helmet>
    </div>
    <div class = "help-container">
      <div class = "help-image">
        <img src={Tutorial} width = '75px'/>
      </div>
      <div class = "help-text">
        <h1 id='help-text'> Tutorial </h1>
        <h1 class = "subheading-text"> How to use the chatbot </h1>
        <div class = "line-help">
          <hr></hr>
        </div>
        <h1 class = "heading-text"> Accessing the Chatbot </h1>
        <h1 class = "body-text"> To Access the chat bot, you need to first login. The login can be found at the top navigation bar or you will be prompted to login upon 
          navigating to the chat bot</h1>
        <h1 class = "heading-text"> Chatting with the Chatbot </h1>
        <h1 class = "body-text"> To chat with the chatbot, simply type your message in the chat box and press enter. The chatbot will do its best to respond with an appropriate answer. The chatbot is designed to answer questions related to Zenker’s Diverticulum. Please keep your questions clear and specific so the chatbot can give you the most accurate and helpful response. It is not designed to offer personalized medical diagnosis, medication recommendations and dosages, or guidance in emergencies or life threatening situations, please consult your doctor directly. </h1>
        <h1 class = "heading-text"> View Chat History </h1>
        <h2 class = "body-text"> To view chat history, click on the chat history button found on the left of the chatbot. This will show you all the previous conversations 
          you have had with the chatbot</h2>
        <h1 class = "heading-text"> Finding General Information </h1>
        <h2 class = "body-text"> General information about Zenker's Diverticulum can be found on the information page. There is an associated FAQ for the surgery and its post operative. </h2>
        <h1 class = "heading-text"> Obtaining Login Credentials </h1>     
        <h2 class = "body-text"> A login username and password will be provided to you by Dr. Benjamin Van Der Woerd. If you are missing login credentials, please contact: <a href = "mailto:vanderw@mcmaster.ca"> vanderw@mcmaster.ca </a></h2>
      </div>
      </div>
      <Footer/>
    </div>
  );
};

export default help;